"use strict";

exports.__esModule = true;
exports.isShoppingCart = exports.bodyWithShoppingCart = void 0;

const isShoppingCart = body => body.some(item => item.shoppingCart);

exports.isShoppingCart = isShoppingCart;

const transformCartItem = (item, productVariants) => {
  const cartProduct = productVariants.find(cartVariant => cartVariant.sku === item.variant.sku);
  return { ...item,
    variant: { ...item.variant,
      ...cartProduct
    }
  };
};

const shoppingCartItems = (checkout, productVariants) => checkout.lineItems.map(cartItem => transformCartItem(cartItem, productVariants));

const bodyWithShoppingCart = (body, checkout, productVariants) => body.map(bodyItem => {
  var _bodyItem$shoppingCar;

  return { ...bodyItem,
    shoppingCart: bodyItem.shoppingCart && { ...bodyItem.shoppingCart,
      item: (_bodyItem$shoppingCar = bodyItem.shoppingCart) === null || _bodyItem$shoppingCar === void 0 ? void 0 : _bodyItem$shoppingCar.item.map(cartItem => cartItem && { ...cartItem,
        cartItems: shoppingCartItems(checkout, productVariants)
      })
    }
  };
});

exports.bodyWithShoppingCart = bodyWithShoppingCart;